<template>
    <div class="customConfirm" v-if="isShow">
        <div class="con_box" >
            <div class="context">
                <h6>{{text.type}}</h6>
                <div class="context_text">
                    {{text.msg}}<br><br>
                    {{text.msg2}}
                </div>
                <div class="btn" v-if="text.btn.num == 2">
                    <button @click="close()" class="continue_paper continue_paper_return"></button>
                    <button @click="ok()" class="continue_paper continue_paper_continue"></button>
                </div>
                <div class="btn" v-if="text.btn.num == 1">
                    <button @click="close()" class="continue_paper continue_paper_return"></button>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
    export default {
        data(){
            return{
                isShow:true,
                text:{
                    type:'提示',
                    msg:'确定删除此条信息？',
                    msg2:'确定删除此条信息？',
                    btn:{
                        num:2 //传入预定数字展示按钮内容，如需其他限制可继续添加
//                        ok:'确定',
//                        no:'取消'
                    },
                }
            }
        },
        methods:{
            close(){
                console.log('关闭');
            },
            ok(){
                console.log('确定')
            }
        }
    }
</script>
<style scoped>
    .customConfirm{background-color:rgba(0, 0, 0, 0.6);width: 100%;height: 100%; position: fixed;top: 0;}
    .con_box{width: 710px;height: 280px;background-image: linear-gradient(#464E91, #D1D4E6);
        /*background: -moz-linear-gradient(top, #464E91 0%, #D1D4E6 100%) ;*/
        /*background: -webkit-gradient(linear, left top, left bottom, color-stop(0%,#464E91), color-stop(100%,#D1D4E6))  ;*/
        /*background: -webkit-linear-gradient(top, #464E91 0%,#D1D4E6 100%) ;*/
        /*background: -o-linear-gradient(top, #464E91 0%,#D1D4E6 100%) ;*/
        /*background: -ms-linear-gradient(top, #464E91 0%,#D1D4E6 100%);*/
        border: 2px solid #1F4E83;
        position: absolute;top: 0;bottom: 0;left: 0;right: 0;margin: auto;border-radius: 0;}
    /*.context{padding: 10px;}*/
    .context h6{font-size: 20px;text-align: center;margin: 0;line-height: normal;color: #fff}
    .context_text{width: 92%;margin: 10px auto;background-color: #fff;padding: 30px 25px;color: #000;font-weight: bold;min-height: 175px}
    /*.context p{font-size: 20px;padding: 35px 15px;text-overflow: ellipsis;overflow: hidden;white-space: nowrap;}*/
    .btn{padding:0;text-align: center;}
    /*.btn span{padding: 10px 35px;    color: white;border-radius: 5px;}*/
    .btn button:nth-child(1){margin-right: 10px}
    .btn button:nth-child(2){margin-left: 10px}

    .continue_paper{width: 86px;height: 34px;background: url(../../src/components/exam/img/TEbtnbg8.png) no-repeat;border: 0;margin: 0;cursor: pointer}
    .continue_paper_continue{background-position: 0 -108px}
    .continue_paper_return{background-position: 0 -71px}
</style>